import { Component, TemplateRef, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Globle } from 'src/assets/globle';
import { Category } from '../category/category.model';
import { CategoryService } from '../category/category.service';
import { Product } from '../product/product.model';
import { ProductService } from '../product/product.service';
import { SubCategory } from '../subcategory/subCategory.model';
import { SubcategoryService } from '../subcategory/subcategory.service';
import { productCards } from './productcards.model';
import { ProductcardsService } from './productcards.service';

@Component({
  selector: 'app-productcardsmanagment',
  templateUrl: './productcardsmanagment.component.html',
  styleUrls: ['./productcardsmanagment.component.css'],
  queries: {
    contentRef: new ViewChild("Modal"),
    contentRef1: new ViewChild("ModalView"),
    contentRef2: new ViewChild("ModalEditCard"),
    contentRef3: new ViewChild("ModalDeleteAll"),
  }
})
export class ProductcardsmanagmentComponent implements OnInit {

  cardCode: string = "";

  subCategories: SubCategory[] = [];
  category: Category[] = [];
  products: Product[] = [];
  displayedColumns: string[] = ["productName", "CardsNumber", "serialNumber", "expiryDate", "createDate",
    "info", 'edit', "delete"];
  dataSource!: MatTableDataSource<productCards>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false;
  selectedCategory!: number;
  selectedSubCategory!: number;
  selectedProduct!: number;
  selectedStatus!: number;

  productCardlst: productCards[] = [];
  productCardsObj: productCards = {} as productCards;
  public contentRef!: TemplateRef<any>;
  public contentRef1!: TemplateRef<any>;
  public contentRef2!: TemplateRef<any>;
  public contentRef3!: TemplateRef<any>;
  pageSize: number = 10;
  productStatus: { id: number, name: string }[] = [];
  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;

  _id: number = 0;
  _cardNo: string = ""
  _serialNo: string = "";
  directCharge = false;
  selectedProductStatus = 1
  constructor(private service: ProductcardsService,
    private categoryService: CategoryService,
    private subCategoryService: SubcategoryService,
    private productService: ProductService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private globle: Globle) { }

  ngOnInit(): void {
    this.productStatus = [{ id: 1, name: "active" }, { id: 0, name: "notActive" }];
    this.selectedStatus = -1;
    this.pageSize = this.globle.pageSize;
    this.getCategory();
  }

  getCategory() {
    this.spinnerOverlay = true;
    this.categoryService.getAll(1, false).subscribe(data => {
      this.category = data;
      this.spinnerOverlay = false;

    }, error => {
      this.spinnerOverlay = false;
      console.log(error)
    })
  }

  getSubCategory() {
    this.spinnerOverlay = true;
    this.subCategoryService.getAll(this.selectedCategory, 1).subscribe(data => {
      this.subCategories = data
      this.spinnerOverlay = false;
    }, error => {
      this.spinnerOverlay = false;
      console.log(error)
    });
  }

  getProduct() {
    this.spinnerOverlay = true;
    this.productCardlst = []
    this.productService.getAll(this.selectedSubCategory, this.selectedProductStatus).subscribe(data => {
      this.products = data;
      this.spinnerOverlay = false;
    }, error => {
      this.spinnerOverlay = false;
      console.log(error)
    })
  }

  selectProductStatusChange() {
    this.getProduct();
  }

  getProductCards() {
    this.spinnerOverlay = true;
    this.service.getAll(this.cardCode, this.selectedCategory, this.selectedSubCategory,
      this.selectedProduct, this.selectedStatus, this.fromDate.nativeElement.value,
      this.toDate.nativeElement.value).subscribe(data => {
        this.productCardlst = data;

        this.dataSource = new MatTableDataSource(this.productCardlst);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinnerOverlay = false;
      },
        error => {
          this.spinnerOverlay = false;
          this.productCardlst = [];
          this.dataSource = new MatTableDataSource(this.productCardlst);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
  }

  search() {
    this.getProductCards();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openDialogView(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '500px',
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onCancel(obj: any) {
    this.productCardsObj = obj;
    this.openDialog();
  }

  info(data: any) {
    this.productCardsObj = data;
    this.openDialogView();
  }

  clearTable() {
    this.productCardlst = [];
    this.dataSource = new MatTableDataSource(this.productCardlst);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  onCategoryChange() {
    this.clearTable();
    this.selectedSubCategory = 0;
    this.getSubCategory();
    // this.getProductCards();
  }

  onsubCategoryChange() {
    this.clearTable();
    this.selectedProduct = 0;
    this.getProduct();
    this.getProductCards();
  }

  statusChange() {
    this.getProductCards();
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  cancelCard() {
    this.dialog.closeAll();
    this.spinnerOverlay = true;
    this.service.cancelCard(this.productCardsObj.id, this.productCardsObj.productId,
      this.productCardsObj.status).subscribe(data => {
        this.spinnerOverlay = false;
        this.search();
        this.openSnackBar("تم الالغاء بنجاح", 'snackBarSuccess');
      },
        error => {
          this.spinnerOverlay = false;
          console.log(error);
          this.openSnackBar(error.error.message, 'snackBarError');
        })
  }

  confirmCancel() {
    this.cancelCard();
  }

  onDateSearch() {
    this.getProductCards();
  }

  onEdit(item: any) {
    this._id = item.id;
    this._cardNo = item.cardNumber;
    this._serialNo = item.serialNumber;
    this.openDialogEdit();
  }

  openDialogEdit(): void {
    const dialogRef = this.dialog.open(this.contentRef2, {
      width: '500px',
    });
  }

  update() {
    var obj = {
      id: this._id,
      cardNumber: this._cardNo,
      serialNumber: this._serialNo
    }
    this.spinnerOverlay = true;
    this.service.update(obj).subscribe(data => {
      this.spinnerOverlay = false;
      this.search();
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.dialog.closeAll();
    }, error => {
      this.spinnerOverlay = false;
      console.log(error);
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }

  onDeleteAll() {
    if (!this.selectedProduct) {
      this.openSnackBar("الرجاء اختيار منتج", 'snackBarError');
    }
    else if (!this.fromDate.nativeElement.value || !this.toDate.nativeElement.value) {
      this.openSnackBar("الرجاء اختيار من تاريخ الى تاريخ", 'snackBarError');
    }
    else {
      if (this.productCardlst.length > 0) {
        this.openDialogDeleteAll()
      }
      else {
        this.openSnackBar("لا يوجد بيانات", 'snackBarError');
      }
    }
  }

  openDialogDeleteAll(): void {
    const dialogRef = this.dialog.open(this.contentRef3, {
      width: '400px',
    });
  }

  deleteBulk(ids: any[]) {
    this.spinnerOverlay = true;
    this.dialog.closeAll()
    this.service.DeleteBulk(ids).subscribe(data => {
      this.openSnackBar("تم الحذف بنجاح", 'snackBarSuccess');
      this.search();
    }, error => {
      this.openSnackBar(error.error.message, 'snackBarError');
      this.spinnerOverlay = false;
    })
  }

  confirmDeleteBulk() {
    var ids: any[] = [];
    this.productCardlst.forEach(x => ids.push(x.id));
    this.deleteBulk(ids)
  }


}
